// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1974":"028b4671","2025":"faaf0d44","2141":"42e4bc8f","3072":"028b4671","4189":"028b4671","5551":"81953b18","6770":"72712833"}[chunkId] + ".chunk.css";
};